import { __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';

var styles = {"wrapper":"badge__wrapper_dsznw","s":"badge__s_dsznw","m":"badge__m_dsznw","xl":"badge__xl_dsznw","component":"badge__component_dsznw","background-accent":"badge__background-accent_dsznw","background-specialbg-secondary-transparent":"badge__background-specialbg-secondary-transparent_dsznw","background-primary":"badge__background-primary_dsznw","countWrapper":"badge__countWrapper_dsznw","count":"badge__count_dsznw","outlineCount":"badge__outlineCount_dsznw","l":"badge__l_dsznw","heightS":"badge__heightS_dsznw","heightM":"badge__heightM_dsznw","heightL":"badge__heightL_dsznw","heightXL":"badge__heightXL_dsznw","heightXXL":"badge__heightXXL_dsznw","icon":"badge__icon_dsznw","positive":"badge__positive_dsznw","attention":"badge__attention_dsznw","negative":"badge__negative_dsznw","link":"badge__link_dsznw","tertiary":"badge__tertiary_dsznw","secondary":"badge__secondary_dsznw","primary":"badge__primary_dsznw","graphic-static-light":"badge__graphic-static-light_dsznw","graphic-primary":"badge__graphic-primary_dsznw","outline":"badge__outline_dsznw","outlineColor":"badge__outlineColor_dsznw","dot":"badge__dot_dsznw","isHidden":"badge__isHidden_dsznw"};
require('./index.css')

function getSize(height) {
    if (height >= 16 && height <= 18)
        return 'heightS';
    if (height >= 19 && height <= 24)
        return 'heightM';
    if (height >= 25 && height <= 32)
        return 'heightL';
    if (height >= 33 && height <= 40)
        return 'heightXL';
    if (height >= 41)
        return 'heightXXL';
    return '';
}
/**
 * @deprecated Используйте StatusBadge или Indicator
 */
// eslint-disable-next-line complexity
var Badge = function (_a) {
    var _b, _c;
    var className = _a.className, _d = _a.size, size = _d === void 0 ? 'm' : _d, view = _a.view, _e = _a.visibleIconOutline, visibleIconOutline = _e === void 0 ? false : _e, _f = _a.visibleColorOutline, visibleColorOutline = _f === void 0 ? false : _f, content = _a.content, _g = _a.height, height = _g === void 0 ? 16 : _g, iconColor = _a.iconColor, _h = _a.color, color = _h === void 0 ? 'accent' : _h, _j = _a.iconUnderlayColor, iconUnderlayColor = _j === void 0 ? 'static-light' : _j, dataTestId = _a.dataTestId;
    var isCountView = view === 'count';
    var isHidden = isCountView && typeof content === 'number' && content <= 0;
    var componentContent = isCountView && content && content >= 100 ? '99+' : content;
    var heightSize = getSize(height);
    return (React.createElement("div", { className: cn(!isCountView && styles.wrapper, iconColor && styles[iconColor], (_b = {},
            _b[styles[size]] = !isCountView,
            _b[styles.outline] = !isCountView && visibleIconOutline,
            _b[styles.outlineColor] = !isCountView && visibleColorOutline,
            _b[styles.countWrapper] = isCountView,
            _b), className), "data-test-id": dataTestId },
        React.createElement("div", { className: cn(styles.component, styles[size], styles[view], styles["background-".concat(color)], styles["graphic-".concat(iconUnderlayColor)], iconColor && styles[iconColor], (_c = {},
                _c[styles[heightSize]] = isCountView,
                _c[styles.isHidden] = isHidden,
                _c[styles.dot] = !content,
                _c[styles.outlineCount] = isCountView && visibleIconOutline,
                _c)), style: __assign({}, (isCountView && content && { height: height, minWidth: height })) }, componentContent)));
};

export { Badge };
